import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { Reservation, ReservationSearchCriteria, ReservationStatus, SearchResults } from "../model/common.model";

@Injectable({
  providedIn: "root"
})
export class ReservationService {
  constructor(private http: HttpClient) { }

  // Customer places a table booking request against the current business.
  request(reservation: Reservation) {
    return firstValueFrom(this.http.post<Reservation>(`/api/reservation/request`, reservation));
  }

  // Business panel: list reservations for the authorised business.
  search(criteria: ReservationSearchCriteria) {
    return firstValueFrom(this.http.post<SearchResults<Reservation>>(`/api/reservation/search`, criteria));
  }

  // Customer: list my own reservations for the current business.
  mine(criteria: ReservationSearchCriteria) {
    return firstValueFrom(this.http.post<SearchResults<Reservation>>(`/api/reservation/mine`, criteria));
  }

  // Business panel: confirm / decline / update a request.
  setStatus(id: string, status: ReservationStatus, reply?: string) {
    return firstValueFrom(this.http.post<Reservation>(`/api/reservation/set-status`, { id, status, reply }));
  }
}
